<script>
import { commands } from '../../js/lib/functions.js'
import { navigate, PageShowError } from '@trullock/page-manager'
import { userChanged } from '../../js/auth.js'
import DateTime from '../../../functions/lib/dateTime.js';
import { showToast } from '../../js/utils/toast.js'
import { hideLoading, showLoading } from '../../js/utils/loading.js';
import { getAuth } from "firebase/auth";
import { getCurrentUserView } from '../../js/readModel.js';
import { cropImage } from '../../js/utils/cropper.js';

export const pageName = 'account-complete';
export const pageRoute = '/account/complete';
export const title = 'Complete Account';
export const requireEmailVerified = false;

export default {
	data() {
		return {
			user: null,
			name: '',
			email: '',
			bornOn: null,
			avatar: null,
			files: [],
			completeMode: false,
			ready: false,
			maxDob: DateTime.today,
			minDob: DateTime.today.addYears(-120)
		}
	},
	methods: {
		async show()
		{
			commands.warmUp();

			this.user = await getCurrentUserView();

			if(this.user.isComplete)
			{
				// cant navigate() inside a show()
				throw new PageShowError('/', 'Account already complete', {}, 'replace');
			}

			this.avatar = this.user.avatar;
			this.bornOn = this.user.bornOn?.format('yyyy-MM-dd');
			this.files = []

			this.ready = true;
		},

		async submit() {
			showLoading();

			this.$refs.fupAvatar.setCustomValidity('');

			if(!this.user.hasSetAvatar && !this.newAvatar)
			{
				this.$refs.fupAvatar.setCustomValidity('Please provide photo ID')
				this.$refs.fupAvatar.reportValidity();
				hideLoading();
				return;
			}

			let updated = userChanged(u => u.isComplete)

			// copy these because the subscription can update them mid-submit
			let newBornOn = new DateTime(this.bornOn);

			let result = await commands.users.account.changeBornOn({ bornOn: newBornOn })
			if(!result.success)
			{
				showToast({ message: 'Error changing your date of bith', style: 'bg-danger'})
				hideLoading();
				return;
			}

			if(this.newAvatar)
			{
				result = await commands.users.account.changeAvatar({ avatar64: this.newAvatar});
				if(!result.success)
				{
					showToast({ message: 'Error changing your avatar', style: 'bg-danger'})
					hideLoading();
					return;
				}
			}
			
			// Force an update as server-side updates don't seem to propagate to the client
			await getAuth().currentUser.reload();
			await updated;
			
			navigate('goal')

			showToast({
				message: 'Account completed',
				style: 'bg-success'
			})

			hideLoading();
		},

		hide()
		{
			this.$refs.fupAvatar.value = null
			this.$refs.lblAvatar.innerHTML = "Choose image&hellip;";
		},
		inputChanged(e) {
			
			var files = e.target.files;

			this.$refs.fupAvatar.setCustomValidity('');
			this.$refs.fupAvatar.reportValidity();

			if (files && files.length > 0) {
				let file = files[0];

				this.$refs.fupAvatar.value = '';
				this.$refs.fupAvatar.blobData = null;
				
				cropImage({
					aspectRatio: 1,
					viewMode: 1,
					autoCropArea: 1
				}, { 
					width: 240, 
					height: 240 
				}, file).then(canvas => {
					this.avatar = canvas.toDataURL();
					this.newAvatar = this.avatar;

					canvas.toBlob(blob => {
						this.$refs.fupAvatar.blobData = {
							blob: blob,
							name: 'avatar.jpg'
						};

						this.$refs.lblAvatar.innerText = file.name;
					});
				}, e => {
					if(e instanceof Error)
					{
						this.$refs.fupAvatar.setCustomValidity(e.message);
						this.$refs.fupAvatar.reportValidity();
					}
				})
			}
		}
	}
}
</script>
<template>
<div class="container" v-if="ready">
    <form @submit.prevent="submit">
		<div class="row justify-content-center">
			<div class="col-12 col-md-6 my-5">
				<h1 class="display-4 text-center mb-3">Complete account</h1>
				<p class="text-muted text-center mb-5">Please complete your account to continue.</p>
				
				<fieldset>
					<div class="form-group">
						<label>Date of birth</label>
						<input type="date" class="form-control" v-model="bornOn" required :max="`${maxDob.format('yyyy-MM-dd')}`" :min="`${minDob.format('yyyy-MM-dd')}`"/>
						<span class="invalid-feedback"></span>
					</div>
				</fieldset>
				<fieldset>
					<div class="field form-group">
						<label class="d-block">
							Photo ID
							
							<div class="row justify-content-center my-3">
								<div class="col">
									<div class="dz-default dz-message py-4">
										<div class="avatar avatar-xxl">
											<img ref="imgAvatar" class="avatar-img rounded-circle" :src="avatar" alt="Your Photo ID">
										</div>
									</div>
								</div>
							</div>
						</label>
						<div class="alert alert-secondary"><span class="fe fe-alert-triangle"></span> Your picture must be a good quality portrait of yourself and will be used for membership verification at launches.</div>
						<div class="custom-file">
							<input type="file" @change="inputChanged" ref="fupAvatar" class="custom-file-input" name="Avatar" accept="image/*;capture=camera">
							<label ref="lblAvatar" class="custom-file-label text-muted">Choose image&hellip;</label>
							<span class="invalid-feedback"></span>
						</div>
						<span class="form-text text-muted small">Must be a jpeg or png</span>
					</div>
				</fieldset>
				
				<button type="submit" class="btn btn-lg btn-primary btn-block">Complete account <span class="fe fe-check-circle"></span></button>
			</div>
		</div>
	</form>
</div>
</template>